export default __webpack_public_path__ + "static/media/deldot.d8aa3cce.png";